import { TmsKey } from 'data/records'
import { resource, collection, member, findSelector } from 'data/helpers/apiv3'

const [api, actions] = resource(TmsKey, [
  ['list', collection.get('', ['tmsJobId', 'tmsSetId', 'q'])],
  ['update', member.patch('', ['tmsSetId', 'tmsSetValidated'])]
])

const selectors = {
  ...findSelector(TmsKey),
  byTmsJobId: (state, tmsJobId) => {
    return state.apiv3.tmsKey.id.filter(k => k.tmsJobId === tmsJobId)
  },
  byTmsSetId: (state, tmsSetId) => state.apiv3.tmsKey.id.filter(k => k.tmsSetId === tmsSetId)
}

const reducers = {}

const initialState = {}

export {
  api as tmsKeyApi,
  actions as tmsKeyActions,
  selectors as tmsKeySelectors,
  reducers as tmsKeyReducers,
  initialState as tmsKeyInitialState
}
